import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Hint from './Hint';
import Typography from '@mui/material/Typography';

const AttrHintSpan = styled('span')({
  marginLeft: '4px',
  display: 'inline-flex',
  fontSize: '18px',
});

const Icon = styled(HelpOutlineIcon)({
  color: '#C1C7D0',
  fontSize: 'inherit',
});

export default ({ children }: { children: string }) => {
  const element = useRef<HTMLElement>(null);

  return <>
    <AttrHintSpan ref={element} ><Icon/></AttrHintSpan>
    <Hint
      anchor={element}
      placement='bottom-start'
    >
      <Typography
        sx={{
          maxWidth: 'calc(70vw);',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '16px',
          letterSpacing: '0em',
          textAlign: 'left'
        }}
      >
        {children}
      </Typography>
    </Hint>
  </>
};
